import { ResourcePage } from "@/components/resource-page"
import { z } from "zod"
import { CreditCard } from "lucide-react"

const paymentSchema = z.object({
  telegram_id: z.string().min(1, "Telegram ID is required"),
  amount: z.number().min(0, "Amount must be positive"),
  order_id: z.string().min(1, "Order ID is required"),
  status: z.enum(["pending", "paid", "cancelled", "expired"]),
})

const paymentColumns = [
  { key: "id", type: "text", options: { label: "ID" } },
  { key: "telegram_id", type: "text", options: { label: "Telegram ID" } },
  { key: "amount", type: "number", options: { label: "Amount" } },
  { key: "order_id", type: "text", options: { label: "Order ID" } },
  { key: "status", type: "status", options: { label: "Status" } },
  { key: "idpay_id", type: "text", options: { label: "IDPay ID" } },
  { key: "paid_at", type: "date", options: { label: "Paid At" } },
  { key: "created_at", type: "date", options: { label: "Created" } },
]

const paymentFormFields = [
  { name: "telegram_id", label: "Telegram ID", type: "text", placeholder: "Enter Telegram ID" },
  { name: "amount", label: "Amount", type: "number", placeholder: "Enter amount" },
  { name: "order_id", label: "Order ID", type: "text", placeholder: "Enter Order ID" },
  {
    name: "status",
    label: "Status",
    type: "select",
    options: [
      { value: "pending", label: "Pending" },
      { value: "paid", label: "Paid" },
      { value: "cancelled", label: "Cancelled" },
      { value: "expired", label: "Expired" },
    ],
  },
]

export default function PaymentsPage() {
  return (
    <ResourcePage
      resource="pricing/purchases"
      title="Payments"
      icon={CreditCard}
      columns={paymentColumns}
      formFields={paymentFormFields}
      formSchema={paymentSchema}
    />
  )
}
